export default __webpack_public_path__ + "static/media/Google-calandar.b6175071.png";